<template>
	<div class="modal-body has-sidebar" v-if="provider">
		<div class="modal-content" :class="{'one-package': provider.products.length <= 1}">
			<h5>Choose a Fibre package.</h5>
			<div class="mobile-provider-logo">
				<svg><use :xlink:href="`#provider-${provider.slug}`"></use></svg>
			</div><!-- end.mobile-provider-logo -->
			<div class="package-cards" :class="`card-size-${cardSize}`">
				<div class="package-card is-selectable"
					 @click.prevent="selectProduct(product)"
					 v-for="product in provider.products"
					 :class="{'is-selected': selectedProduct.id === product.id}"
					 :key="product.id">
					<div class="package-card-header">
						<p>R{{ parseFloat(product.price).toLocaleString('en-ZA') }}<sup>pm</sup></p>
					</div>
					<div class="package-card-footer">
						<svg class="icon"><use xlink:href="#speed-down"></use></svg>
						{{ product.speed_down }}Mbps
						<svg class="icon"><use xlink:href="#speed-up"></use></svg>
						{{ product.speed_up }}Mbps
					</div>
				</div><!-- end.package-card -->
			</div><!-- end.package-cards -->
			<div class="modal-footer">
				<button class="btn white" @click="back()">Go Back</button>
				<of-injector :pre-order="provider.pre_order" :place="latLng" :product-id="selectedProduct.solution_id"></of-injector>
			</div><!-- end.modal-footer -->
		</div><!-- end.modal-content -->
		<modal-sidebar :provider="provider" :solution="this.selectedProduct" :solutions="provider.products"></modal-sidebar>
		<div class="modal-overlay" v-if="provider.pre_order && showOverlay">
			<h6 class="orange">Your area is currently in rollout phase</h6>
			<p>You can pre-order Pure Fibre at <formatted-address :place="place"></formatted-address></p>
			<p>You will only be able to get internet access once {{ provider.name }} has taken your area live and done an installation to your premises. Placing a pre-order with Afrihost is the best way to make sure you're first on the list for connectivity once  {{ provider.name }} is finished and everything's ready to go.</p>
			<button class="btn gradient-red" @click="dismiss()">I Understand</button>
		</div><!-- end.modal-overlay -->
	</div>
</template>
<script>
	import OfInjector from './OrderFormInjector'
	import ModalSidebar from './SideBar'
	import FormattedAddress from "../components/FormattedAddress";

	export default {
		components: {
			OfInjector,
			ModalSidebar,
			FormattedAddress,
		},
		computed: {
			place() {
				return this.$store.getters['coverage/place'];
			},
			latLng() {
				return {
					latitude: this.place.geometry.location.lat(),
					longitude: this.place.geometry.location.lng()
				}
			},
			formattedPlace() {
				return this.$store.getters['coverage/formattedPlace'];
			},
			provider() {
				let p = this.$store.getters['coverage/selectedFibreProvider'];
				let provider = this.$store.getters['providers/providerBySlug'](p.vendor.slug);

				let pObj = {...provider};
				pObj.pre_order = p.pre_order;
				return pObj;
			},
			cardSize() {
				return this.provider.products.length;
			}
		},
		data() {
			return {
				error: false,
				showOverlay: false,
				selectedProduct: false
			}
		},
		methods: {
			back() {
				this.$router.push({name: 'coverage'});
			},
			dismiss() {
				this.showOverlay = false;
			},
			selectProduct(product) {
				this.selectedProduct = product;
			}
		},
		mounted() {
			if(this.provider.pre_order) {
				this.showOverlay = true;
			}
		}
	}
</script>
